<template>
    <div class="row">
        
        <accordion 
            :hideTitle="true"
            class="col-12 mt-3"             
        >
            <detalhes />
        </accordion>

    </div>
</template>
<script>

import Accordion from '@/components/card/Accordion';
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import Detalhes from "./accordions/detalhes"
export default {
    name: "ProjetoGestaoForm",
    components: {
        Accordion,
        Detalhes
    },
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Projetos de gestão / GPPDI", to: {name: "projeto-gestao-proponente-lista"}},
            {titulo : "Novo"}
        ]);
    },
    
}   
</script>
<style>
</style>